export const INGRESO_DIVISAS_CATEGORY = 'Ingreso divisas';
